import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  create(data) {
    const { attachment, audienceCsv, ...payload } = data;

    if (!attachment && !audienceCsv) return super.create(payload);

    const formData = new FormData();
    if (attachment) formData.append('attachment', attachment);
    if (audienceCsv) formData.append('audience_csv', audienceCsv);

    Object.keys(payload).forEach(key => {
      const value = payload[key];
      // Serialize objects/arrays to JSON before appending
      if (typeof value === 'object' && value !== null) {
        formData.append(`campaign[${key}]`, JSON.stringify(value));
      } else {
        formData.append(`campaign[${key}]`, value);
      }
    });

    return super.multipartCreate(formData);
  }
}

export default new CampaignsAPI();
